<template>
  <footer class="footer">
    <div class="about">
      <img
        alt="Livestorm Logo"
        class="logo"
        height="24"
        loading="lazy"
        src="@/assets/svg/logo-black.svg"
        width="143"
      >
    </div>
    <div class="certifications">
      <UiComponentImage
        v-for="{ id, medal } in data.extraInformations.certifications"
        :key="id"
        :alt="medal.alt"
        :expected-size="68"
        :extra-params="{
          trim: 'color',
        }"
        :height="medal.height"
        :orientation="medal.width > medal.height ? 'portrait' : 'landscape'"
        :source="medal.url"
        use-natural-height
        use-natural-width
        :width="medal.width"
      />
    </div>
    <div class="copyright">
      {{ copyright }}
    </div>
  </footer>
</template>

<script setup>
// Composables
const { locale } = useI18n()
const { state } = useConditionalPreviewMode()
const { $interpolate } = useNuxtApp()

// Computed Propeties
const copyright = computed(() => {
  return $interpolate(data.value.extraInformations.wordingLivestormCopyright, {
    '%{year}': new Date().getFullYear(),
  })
})

// Async Data
const { data } = await useFetch(`/api/content/components/footer/${locale.value}`, {
  key: `component-footer-light-${locale.value}`,
  query: {
    preview: state.preview,
  },
})
</script>

<style lang="postcss" scoped>
.footer {
  @apply flex flex-col items-center w-full mt-34 mb-8;

  .about {
    @apply flex flex-col items-center w-full;

    .logo {
      @apply h-6 w-auto;
    }
  }

  .certifications {
    @apply flex flex-row flex-wrap justify-around mt-6;

    @screen md {
      @apply justify-start;
    }

    @screen lg {
      @apply items-center;
    }

    picture {
      @apply mx-4 mt-8 rounded-none;

      @screen md {
        @apply mx-3;
      }

      @screen lg {
        @apply mt-0;
      }

      &:first-child {
        @apply ml-0;
      }

      &:last-child {
        @apply mr-0;
      }
    }
  }

  .copyright {
    @apply flex mt-6 text-grey-blue-600 text-sm leading-6;
  }
}
</style>
